import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { EventType } from '../enums/enums/event-type';
import { ShellLoggingService } from './shell-logging/shell-logging.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: Error): void {
    const shellLoggingService = this.injector.get(ShellLoggingService);
    shellLoggingService.log(
      EventType.Error,
      error?.message || 'Uncaught error',
      { stack: error?.stack },
      error
    );
    console.error(error);
  }
}
